import React, { useState, useContext } from "react";
import { GraphContext } from "../context";
import { Button, Grid } from "@mui/material";
import CustomButton from "../components/Common/CustomButton";

function BestFirstSearch() {
  const {
    graphOptions,
    nodes,
    edges,
    setFinalPath,
    setTraverseDetails,
    setEdgeFinalPath,
  } = React.useContext(GraphContext);
  const { inputField, connection } = graphOptions;
  const { startNode, goalNode } = inputField;
  const allObjectsHaveValues = nodes.every((obj) => {
    return obj.label === "";
  });

  const bestFirstSearch = () => {
    // intialize mandantory variables
    const selectedAvailableNode = nodes.map((item) => {
      return item.title;
    });
    if (
      !selectedAvailableNode.includes(startNode) ||
      !selectedAvailableNode.includes(goalNode)
    ) {
      alert("please select available node");
      return;
    }
    const priorityQueue = [];
    const visited = new Set();
    const parent = {};
    let traverseArr = [];
    const getNodeById = (nodes, id) => {
      return nodes.find((node) => node.id === id);
    };
    // finding one starting node and goal node object from the node array
    const startNodeS = nodes.find((node) => node.title === startNode);
    const goalNodeS = nodes.find((node) => node.title === goalNode);

    // pushing the intial node to priorityQueue
    priorityQueue.push(startNodeS);

    for (let i = 0; priorityQueue.length > 0; i++) {
      priorityQueue.sort((nodeA, nodeB) => {
        return nodeA.label - nodeB.label;
      });

      const currentNode = priorityQueue.shift();

      visited.add(currentNode);

      if (currentNode === goalNodeS) {
        const pathNodes = [];
        let node = currentNode;
        while (node !== startNodeS) {
          pathNodes.unshift(node);
          node = parent[node.id];
        }
        pathNodes.unshift(startNodeS);

        // Store the edges belonging to the final path
        const pathEdges = edges
          .filter((edge) => {
            return (
              pathNodes.some((node) => node.id === edge.from) &&
              pathNodes.some((node) => node.id === edge.to)
            );
          })
          .map((item) => {
            return {
              ...item,
              color: "green",
              width: 2,
            };
          });

        setEdgeFinalPath(pathEdges);
        traverseArr.push(
          <p style={{ color: "white" }}>
            Final Path is:{"   "}
            <span style={{ color: "yellow", fontWeight: "bold" }}>
              {"  "}
              {Array.from(pathNodes)
                .map((visited) => visited.title)
                .join(" -> ")}
            </span>
          </p>
        );

        setFinalPath(pathNodes);
        return;
      }

      traverseArr.push(
        <p style={{ color: "white" }}>
          Select the Node with the highest priority, which is node{" "}
          <span style={{ color: "Black", fontWeight: "bold" }}>
            {" "}
            {currentNode.title}{" "}
          </span>{" "}
          with priority{" "}
          <span style={{ color: "orange", fontWeight: "bold" }}>
            {currentNode.label}
          </span>
        </p>
      );
      traverseArr.push(
        <p style={{ color: "white" }}>
          Traverse to node{" "}
          <span style={{ color: "Black", fontWeight: "bold" }}>
            {currentNode.title}
          </span>{" "}
          and its neighbours{" "}
          <span style={{ color: "black", fontWeight: "bold" }}>
            {" "}
            {Array.from(visited)
              .map((visited) => visited.title)
              .join(",")}
          </span>{" "}
          to the list of nodes to be visited.
        </p>
      );
      // const neighbors = edges
      //   .filter((edge) => edge.to === currentNode.id)
      //   .map((edge) => getNodeById(nodes, edge.from));
      // edges.forEach((edge, index) => {
      //   if (edge.from === currentNode.id) {
      //     console.log("working", currentNode, nodes, edge);
      //     const neighborNode = nodes.find((node) => node.id === edge.to);
      //     const neighborNode1 = nodes.find((node) => node.id === edge.from);
      //     console.log(neighborNode1);
      //     if (!visited.has(neighborNode)) {
      //       priorityQueue.push(neighborNode);
      //       parent[neighborNode.id] = currentNode;
      //     }
      //   }
      // });

      // this variable return node id depends on direction
      const neighborIds = edges
        .filter((edge) =>
          connection === "Undirected"
            ? edge.from === currentNode.id || edge.to === currentNode.id
            : edge.from === currentNode.id
        )
        .map((edge) =>
          connection === "Undirected"
            ? edge.from === currentNode.id
              ? edge.to
              : edge.from
            : edge.to
        );
      // this variable return node list by providing nodeId
      const neighborNode = neighborIds.map((neighborId) =>
        getNodeById(nodes, neighborId)
      );

      for (const neighbor of neighborNode) {
        if (!visited.has(neighbor)) {
          priorityQueue.push(neighbor);
          parent[neighbor.id] = currentNode;
        }
      }

      setTraverseDetails(traverseArr);
    }

    setFinalPath([]);
  };

  return (
    <Grid marginTop={2}>
      <CustomButton
        varient={"contained"}
        lable={"Search Path"}
        onClick={bestFirstSearch}
        isDisabled={startNode === "" || goalNode === "" || allObjectsHaveValues}
      />
    </Grid>
  );
}

export default BestFirstSearch;
